import { Title } from "../../Atoms/Title";
import { FormCollaboratorRegister } from "../../Molecules/FormCollaboratorRegister";
import * as S from "./styles";
import { useCollaboratorRegister } from "./useCollaboratorRegister";

export const CollaboratorRegisterTemplate = () => {
  const { onSubmit } = useCollaboratorRegister();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Cadastro Colaboradores</Title>
        <FormCollaboratorRegister submitForm={onSubmit} />
      </S.Wrapper>
    </S.Container>
  );
};
